export const SITE_URL =
    process.env.REACT_APP_SITE_URL?.replace(/\/$/, "") || "https://www.accruewise.in";

export const SITE_NAME = "Accruewise";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.webp`;

export const ORGANIZATION = {
    name: "ACCRUEWISE TECHNOLOGIES PRIVATE LIMITED",
    legalName: "ACCRUEWISE TECHNOLOGIES PRIVATE LIMITED",
    url: SITE_URL,
    logo: DEFAULT_OG_IMAGE,
    email: "care@accruewise.in",
    foundingDate: "2024",
    address: {
        streetAddress: "24th Floor, Tower B, Alphathum Plot No 1 Sec90, Nepz Post Office",
        addressLocality: "Noida",
        addressRegion: "Uttar Pradesh",
        postalCode: "201305",
        addressCountry: "IN",
    },
    sameAs: [
        "https://www.linkedin.com/company/accruewise/",
        "https://x.com/accruewise",
        "https://www.instagram.com/accruewise/",
        "https://www.facebook.com/accruewise/",
    ],
};

export const APP_LINKS = {
    googlePlay:
        "https://play.google.com/store/apps/details?id=com.accruewise.app",
    packageName: "com.accruewise.app",
};

export const SITE_DESCRIPTION =
    "Accruewise is an India-first fintech app for saving, budgeting, marketplace shopping, virtual card payments, and spend tracking—all in one place.";

export const SITE_KEYWORDS = [
    "Accruewise",
    "fintech app India",
    "savings app",
    "budgeting app",
    "virtual card",
    "marketplace shopping",
    "spend tracker",
    "UPI savings",
    "personal finance India",
].join(", ");
